import type {
  Partnersv2BatchGetAccountsRequest,
  Partnersv2BatchGetAccountsResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/partners/v2/account_api';
import { awIntegrationsApi } from './Base';
import {
  AGraphExchangeAuthorizationCodeRequest,
  AGraphFilterPlatformsRequest,
  AGraphFilterPlatformsResponse,
  AGraphSearchExternalAccountInfoRequest,
  AGraphSearchExternalAccountInfoResponse,
} from './types';

export function getPlatforms(payload: AGraphFilterPlatformsRequest) {
  const path = '/partners/v1/platforms:filter';
  return awIntegrationsApi.post<AGraphFilterPlatformsResponse>(path, payload);
}

export function exchangeAuthCode(payload: AGraphExchangeAuthorizationCodeRequest) {
  const path = `/partners/v1/platforms:exchangeAuthorizationCode`;
  return awIntegrationsApi.post(path, payload);
}

export function searchExternalAccountInfos(payload: AGraphSearchExternalAccountInfoRequest) {
  const path = '/partners/v1/externalAccountInfos:search';
  return awIntegrationsApi.post<AGraphSearchExternalAccountInfoResponse>(path, payload);
}

export function batchGetExternalAccounts(payload: Partnersv2BatchGetAccountsRequest) {
  const path = '/partners/v2/accounts:batchGet';
  return awIntegrationsApi.post<Partnersv2BatchGetAccountsResponse>(path, payload);
}
